import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { formatDuration } from '@halo/utils';
import { Fragment } from 'react/jsx-runtime';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { useUserInfoList } from '@/scripts/hooks/useUserInfoList';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupRestrictedContentProps {
  message: Msg;
}

export const MsgGroupRestrictedContent = memo(function MsgGroupRestrictedContent({
  message,
}: MsgGroupRestrictedContentProps) {
  const { t } = useTranslation();
  // duration_time: Unit: milliseconds, 0 indicates permanent mute
  const { operator_user_id, target_user_ids, duration_time } = message.payload;

  const { user: operatorUser } = useUserInfo(operator_user_id);
  const { users: members } = useUserInfoList(target_user_ids);

  return (
    <MyTrans
      i18nKey="chat.groupMessageRestrictedText"
      components={{
        actionUser: <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />,
        action: <Text as="span" color="fg.muted" />,
        members: (
          <>
            {members?.map((user, index) => (
              <Fragment key={user.user_id}>
                {index > 0 && ', '}
                <MsgUserText userName={user.name} userId={user.user_id} />
              </Fragment>
            ))}
          </>
        ),
        other: <Text as="span" color="fg.muted" />,
      }}
      values={{
        duration: duration_time === 0 ? t('chat.permanentText') : formatDuration(duration_time),
      }}
    ></MyTrans>
  );
});
